/**
 * Common re-usable util functions
 */

import { v4 } from 'uuid'

export const newGuid = () => v4().toString()

export const sleep = async (ms: number) =>
  new Promise<void>(resolve => {
    setTimeout(resolve, ms)
  })

export const objectKeys = Object.keys as <T>(o: T) => (keyof T)[]
